<template>
    <header id="Header">
        <div class="wrap">
            <router-link to="/" style="font-size:25px;">SEVS</router-link>
            <!-- <router-link to="/Program">프로그램</router-link> -->
            <router-link to="/Application">신입지원</router-link>
            <router-link to="/Exhibition">지난전시</router-link>
            <router-link to="/News">뉴스</router-link>
            <router-link to="/Artist">아티스트</router-link>
            <router-link to="/Contact">컨택</router-link>
            <a href="http://vers.kr/"><img src="../assets/logo/vers로고.png"></a>
        </div>
    </header>
</template>

<script>
export default {
    data() {
        return {
            popup:true
        }
    },
    methods:{
		close(){
            this.popup = false
		}
    }
}
</script>

<style lang="scss">
#Header {padding:40px 0; cursor: pointer; background: #e7e5e5b9;
    .wrap{padding: 0 30px 0 15px; 
        a {font-size:1.4rem; font-weight:600; color:rgb(0, 0, 0); margin-right:50px; cursor: pointer;}
        img{width: 6%; float: right; margin-top: 5px;}
    }
}

@media(max-width:767px) {
	#Header {
        .wrap{
            a {font-size:0.9rem; margin: 5px;}
            // img{width: 10%; margin-top: 7px; display: none;}
            img{display: none;}
        }
	}
}
</style>
